import _ from 'lodash/fp';
import { createReducer } from 'reduxsauce';
import { COMPANY, COMPANY_ONBOARDING, LIKES, COMMENTS, HITFACTOR_COLLECTIONS, HITCLUB } from 'actions/Base';
import { arrayMove } from 'utils/helpers';

export const INITIAL_STATE = {
  listCompany: [],
  companyProfile: {},
  companyFeedItems: [],
  companyFollowers: {},
  feedHasMoreItems: false,
  isLoading: false,
  hitEvents: {
    content: []
  }
};

export const onGetDetailRequest = (state) => ({ ...state });
export const onGetDetailSuccess = (state, { payload }) => ({ ...state, companyProfile: payload });
export const onGetDetailFailure = (state) => ({ ...state });

export const onUpdateCompanyRequest = (state) => ({ ...state });
export const onUpdateCompanyFailure = (state) => ({ ...state });
export const onUpdateCompanySuccess = (state, { payload }) => ({ ...state, companyProfile: payload });

export const onUpdateCompanyUserRequest = (state) => ({ ...state });
export const onUpdateCompanyUserFailure = (state) => ({ ...state });
export const onUpdateCompanyUserSuccess = (state, { payload }) => {
  const userIndex = state.companyProfile.companyUsers.findIndex((user) => (
    (user || {}).studentId === payload.studentId
  ));
  
  if (userIndex > -1) {
    return _.set(`companyProfile.companyUsers[${userIndex}]`, payload)(state);
  }

  return state;
};

export const onGetAllRequest = (state) => ({ ...state });
export const onGetAllSuccess = (state, { payload }) => ({ ...state, listCompany: payload });
export const onGetAllFailure = (state) => ({ ...state });

export const onCreateCompanySuccess = (state, { payload }) => {
    return (
      { ...state, companyProfile: payload }
    )
  };

export const onGetFeedRequest = (state, { payload }) => ({ ...state, isLoading: true, size: payload.size || 20, page: payload.page || 0 });
export const onGetFeedFailure = (state) => ({ ...state, isLoading: false });
export const onGetFeedSuccess = (state, { payload }) => {
  if (!payload.page) {
    if(payload.list.length > 0) {
      return ({ ...state, isLoading: false, feedHasMoreItems: true, companyFeedItems: [...payload.list] })
    } 
    else {
      return ({ ...state, isLoading: false, feedHasMoreItems: false, companyFeedItems: [...payload.list] })
    }
  }
  else {
      if(payload.list.length > 0) {
        return ({ ...state, isLoading: false, feedHasMoreItems: true, companyFeedItems: [...state.companyFeedItems, ...payload.list] })
      }
      else {
        return ({ ...state, isLoading: false, feedHasMoreItems: false, companyFeedItems: [...state.companyFeedItems, ...payload.list] })      
      }
    }
};

export const onGetCompanyFollowersRequest = (state) => ({ ...state });
export const onGetCompanyFollowersSuccess = (state, { payload }) => {
  if (payload.pageable.pageNumber === 0) {
      return ({ ...state, companyFollowers: payload });
  }
  else {
        return ({ 
          ...state, 
          companyFollowers: {
            ...payload,
            content: [ ...state.companyFollowers.content, ...payload.content]
          }
        })
    }
};

export const onGetCompanyFollowersFailure = (state) => ({ ...state });

export const onCreateCompanyPostRequest = (state) => ({ ...state, isLoading: true });
export const onCreateCompanyPostSuccess = (state, { payload }) => ( { ...state, isLoading: false, companyFeedItems: [payload, ...state.companyFeedItems] } );
export const onCreateCompanyPostFailure = (state) => ({ ...state, isLoading: false });

export const onCreateUserRequest = (state) => ({ ...state, isLoading: true });
export const onCreateUserSuccess = (state, { payload }) => {
  const newState = _.cloneDeep(state);
  newState.companyProfile.companyUsers.push(payload);
  return ({ ...newState });
};

export const onCreateUserFailure = (state) => ({ ...state, isLoading: false });

export const onLikeCreate = (state, { payload }) => {

  const feedIndex = state.companyFeedItems.findIndex((feed) => (
    (feed.object || {}).id === payload.entityId &&
    feed.object.targetEntityType === _.get('entityType')(payload)
  ));
  
  if (feedIndex > -1) {
    const current = _.cloneDeep(_.get(`companyFeedItems.[${feedIndex}]`)(state) || {});

    if (current.object) {
      current.object.loggedInUserLiked = true;
      return _.set(`companyFeedItems.[${feedIndex}]`, current)(state);
    }
  }

  return state;
};

export const onLikeDelete = (state, { payload }) => {

  const feedIndex = state.companyFeedItems.findIndex((feed) => (
    (feed.object || {}).id === payload.entityId &&
    feed.object.targetEntityType === _.get('entityType')(payload)
  ));
    
  if (feedIndex > -1) {
    const current = _.cloneDeep(_.get(`companyFeedItems.[${feedIndex}]`)(state) || {});

    if (current.object) {
      current.object.loggedInUserLiked = false;
      return _.set(`companyFeedItems.[${feedIndex}]`, current)(state);
    }
  }

  return state;
};

const onCommentCreate = (state, { payload }) => {
  const companyFeedItems = _.cloneDeep([...state.companyFeedItems]);
  for (let i=0; i<companyFeedItems.length; i++) {
    if (!!companyFeedItems[i].object && companyFeedItems[i].object.id===payload.entityId) {
      companyFeedItems[i].object.numberOfComments++;
      return { ...state, companyFeedItems };
    }
  }
  return state;
};

const onCommentDelete = (state, { payload }) => {
  const companyFeedItems = _.cloneDeep([...state.companyFeedItems]);
  for (let i=0; i<companyFeedItems.length; i++) {
    if (!!companyFeedItems[i].object && companyFeedItems[i].object.id===payload.entityId) {
      companyFeedItems[i].object.numberOfComments--;
      return { ...state, companyFeedItems };
    }
  }
  return state;
};

const onCreateCollectionSuccess = (state, { payload }) => {
  const newState = _.cloneDeep(state);
  newState.companyProfile.inspirationCollections.push(payload);
  return ({ ...newState });
};

const onUpdateCollectionSuccess = (state, { payload }) => {
  const inspirationCollections = _.cloneDeep(_.get(`companyProfile.inspirationCollections`)(state) || {});

  const collectionIndex = inspirationCollections.findIndex((collection) => (
    (collection || {}).id === payload.inspirationCollectionId ));

  inspirationCollections[collectionIndex].title = payload.title
  inspirationCollections[collectionIndex].caption = payload.caption
  inspirationCollections[collectionIndex].pictureUrl = payload.pictureUrl
  inspirationCollections[collectionIndex].picture = payload.picture
  inspirationCollections[collectionIndex].updated = payload.updated

  return _.set(`companyProfile.inspirationCollections`, inspirationCollections)(state);
}

const onCreateCollectionImageSuccess = (state, { payload }) => {
  const feedIndex = state.companyProfile.inspirationCollections.findIndex((collection) => (
    (collection || {}).inspirationCollectionId === payload.inspirationCollectionId
  ));
  
  if (feedIndex > -1) {
    let newState = _.cloneDeep(_.get(`companyProfile.inspirationCollections[${feedIndex}]`)(state) || {});

    if (newState) {
      newState = payload;

      return _.set(`companyProfile.inspirationCollections[${feedIndex}]`, newState)(state);
    }
  }

  return state;
};

const onUpdateCollectionImageSuccess = (state, { payload }) => {
  const collectionIndex = state.companyProfile.inspirationCollections.findIndex((collection) => (
    (collection || {}).inspirationCollectionId === payload.collectionId
  ));
  
  if (collectionIndex > -1) {
    let newState = _.cloneDeep(_.get(`companyProfile.inspirationCollections[${collectionIndex}]`)(state) || {});

    if (newState) {
      const inspirationIndex = newState.inspirations.findIndex((inspiration) => (
        (inspiration || {}).inspirationId === payload.inspirationId
      ));
      newState.inspirations[inspirationIndex].caption = payload.caption;

      return _.set(`companyProfile.inspirationCollections[${collectionIndex}]`, newState)(state);
    }
  }

  return state;
};

const onMoveImageImageRequest = (state, { payload }) => {
  const collectionIndex = state.companyProfile.inspirationCollections.findIndex((collection) => (
    (collection || {}).inspirationCollectionId === payload.collectionId
  ));
  
  if (collectionIndex > -1) {
    let newState = _.cloneDeep(_.get(`companyProfile.inspirationCollections[${collectionIndex}]`)(state) || {});

    if (newState) {
      const inspirationIndex = newState.inspirations.findIndex((inspiration) => (
        (inspiration || {}).inspirationId === payload.inspirationId
      ));
      
      if(payload.direction === 'right') {
        newState.inspirations = arrayMove(newState.inspirations, inspirationIndex, inspirationIndex+1);
      }
      else if(payload.direction === 'left') {
        newState.inspirations = arrayMove(newState.inspirations, inspirationIndex, inspirationIndex-1);
      }
      return _.set(`companyProfile.inspirationCollections[${collectionIndex}]`, newState)(state);
    }
  }

  return state;
};

const onMoveCollectionRequest = (state, { payload }) => {

  let newState = _.cloneDeep(_.get(`companyProfile.inspirationCollections`)(state) || {});

  const collectionIndex = newState.findIndex((collection) => (
    (collection || {}).inspirationCollectionId === payload.collectionId
  ));
  
  if (collectionIndex > -1) {
    if (newState) {
      if(payload.direction === 'right') {
        newState = arrayMove(newState, collectionIndex, collectionIndex+1);
      }
      else if(payload.direction === 'left') {
        newState = arrayMove(newState, collectionIndex, collectionIndex-1);
      }
      return _.set(`companyProfile.inspirationCollections`, newState)(state);
    }
  }

  return state;
};


const onDeleteCollectionSuccess = (state, { payload }) => {
  const inspirationCollectionsIndex = state.companyProfile.inspirationCollections.findIndex((collection) => (
    (collection || {}).inspirationCollectionId.toString() === payload.inspirationCollectionId.toString()
  ));
  
  if (inspirationCollectionsIndex > -1) {
    const currentInspirationCollections = _.cloneDeep(_.get(`companyProfile.inspirationCollections`)(state) || {});

    delete currentInspirationCollections[inspirationCollectionsIndex]

    return _.set(`companyProfile.inspirationCollections`, currentInspirationCollections)(state);
  }

  return state;
};

const onDeleteImageSuccess = (state, { payload }) => {
  const inspirationCollectionsIndex = state.companyProfile.inspirationCollections.findIndex((collection) => (
    (collection || {}).inspirationCollectionId.toString() === payload.collectionId.toString()
  ));
  
  if (inspirationCollectionsIndex > -1) {
    const currentInspirations = _.cloneDeep(_.get(`companyProfile.inspirationCollections[${inspirationCollectionsIndex}].inspirations`)(state) || {});

    const newInspirationsState = currentInspirations.filter((item) => item.inspirationId !== payload.inspirationId);

    return _.set(`companyProfile.inspirationCollections[${inspirationCollectionsIndex}].inspirations`, newInspirationsState)(state);
  }

  return state;
};

const onUpdateCompanyCoverImageSuccess = (state, { payload }) => {
  const companyProfile = _.cloneDeep(_.get(`companyProfile`)(state) || {});

  companyProfile.headerPictureUrl = payload.headerPictureUrl
  companyProfile.headerLogo = payload.headerLogo

  return _.set(`companyProfile`, companyProfile)(state);
};

const onDeleteHitPostSuccess = (state, { payload }) => {

    const currentPosts = _.cloneDeep(_.get(`companyFeedItems`)(state) || {});

    const newCurrentPosts = currentPosts.filter((item) => (item.object.id !== payload.entityId 
      && item.object.targetEntityType !== payload.targetEntityType)
    );

    return _.set(`companyFeedItems`, newCurrentPosts)(state);

};

export const onConnectInstagramRequest = (state) => ({ ...state, isLoading: true });
export const onConnectInstagramFailure = (state) => ({ ...state, isLoading: false });
export const onConnectInstagramSuccess = (state, { payload }) => {

  return {
    ...state, 
    isLoading: false, 
    companyProfile: { ...state.companyProfile, ...payload }
  };

};

export const onDeleteInstagramRequest = (state) => ({ ...state, isLoading: true });
export const onDeleteInstagramFailure = (state) => ({ ...state, isLoading: false });
export const onDeleteInstagramSuccess = (state, { payload }) => {

  return {
    ...state, 
    isLoading: false, 
    companyProfile: { ...state.companyProfile, ...payload }
  };

};

export const onGetCompanyHitEventsRequest = (state) => ({ ...state, isLoading: true });
export const onGetCompanyHitEventsFailure = (state) => ({ ...state, isLoading: false });
export const onGetCompanyHitEventsSuccess = (state, { payload }) => {
  return ({ ...state, isLoading: false, hitEvents: payload });
}

export const onCreateTicketRequest = (state) => ({ ...state, isLoading: true });
export const onCreateTicketFailure = (state) => ({ ...state, isLoading: false });
export const onCreateTicketSuccess = (state, { payload }) => {

  let hitEvents = _.cloneDeep(_.get(`hitEvents.content`)(state) || {});

  if(hitEvents.length) {
    const currentHitEventIndex = hitEvents.findIndex((hitEvent) => (
      (hitEvent || {}).hitEventId === payload.entityId
    ));

    if(currentHitEventIndex > -1) {
      hitEvents[currentHitEventIndex].ticketTypes = (hitEvents[currentHitEventIndex].ticketTypes || []).concat([payload])   
      state.isLoading = false
      return _.set(`hitEvents.content`, hitEvents)(state);
    }
  
  }

  return ({ ...state, isLoading: false })
};

export const onEditTicketRequest = (state) => ({ ...state, isLoading: true });
export const onEditTicketFailure = (state) => ({ ...state, isLoading: false });
export const onEditTicketSuccess = (state, { payload }) => {

  if(!!payload?.hitEvent?.company?.companyId) {
    return {
      ...state,
      isLoading: false,
      hitEvents: { 
        ...state.hitEvents,
        content: state.hitEvents.content.map(hitEvent => 
          (hitEvent || {}).hitEventId === payload.hitEvent.hitEventId ? 
            { 
              ...hitEvent, 
              ticketTypes: hitEvent.ticketTypes.map(ticket => 
                (ticket || {}).ticketTypeId === payload.ticketTypeId ?  
                { ...ticket, ...payload }
                :
                ticket
              )
            } 
            : hitEvent
        )
      }
    };
  }
  else {
    return state;
  }

};

export const onCreateTicketQuestionsRequest = (state) => ({ ...state, isLoading: true });
export const onCreateTicketQuestionsFailure = (state) => ({ ...state, isLoading: false });
export const onCreateTicketQuestionsSuccess = (state, { payload }) => {

  const { data, ticketTypeId, hitEventId } = payload

  return {
    ...state,
    isLoading: false,
    hitEvents: { 
      ...state.hitEvents,
      content: state.hitEvents.content.map(hitEvent => 
        (hitEvent || {}).hitEventId === hitEventId ? 
          { ...hitEvent, 
            ticketTypes: hitEvent.ticketTypes.map(ticket => (
              (ticket || {}).ticketTypeId === ticketTypeId ?
              { ...ticket, dynamicInfo: { ...data } } : ticket
            ))
          } 
          : hitEvent
      )
    }
  };

};

export const onEditTicketQuestionsRequest = (state) => ({ ...state, isLoading: true });
export const onEditTicketQuestionsFailure = (state) => ({ ...state, isLoading: false });
export const onEditTicketQuestionsSuccess = (state, { payload }) => {

  const { data, ticketTypeId, hitEventId } = payload

  return {
    ...state,
    isLoading: false,
    hitEvents: { 
      ...state.hitEvents,
      content: state.hitEvents.content.map(hitEvent => 
        (hitEvent || {}).hitEventId === hitEventId ? 
          { ...hitEvent, 
            ticketTypes: hitEvent.ticketTypes.map(ticket => (
              (ticket || {}).ticketTypeId === ticketTypeId ?
              { ...ticket, dynamicInfo: { ...data } } : ticket
            ))
          } 
          : hitEvent
      )
    }
  };

};

export const onCreateHitEventRequest = (state, { params }) => ({ ...state, isLoading: true });
export const onCreateHitEventFailure = (state) => ({ ...state, isLoading: false });
export const onCreateHitEventSuccess = (state, { payload }) => {
  return {
    ...state,
    isLoading: false,
    hitEvents: {
      ...state.hitEvents, 
      content: (state.hitEvents.content||[]).concat(payload)
    }
  };
};

export const onRemoveHitEventRequest = (state, { params }) => ({ ...state, isLoading: true });
export const onRemoveHitEventFailure = (state) => ({ ...state, isLoading: false });
export const onRemoveHitEventSuccess = (state, { payload }) => {

  if(!!state?.hitEvents?.content) {
    return {
      ...state,
      isLoading: false,
      hitEvents: { 
        ...state.hitEvents,
        content: [
          ...state.hitEvents.content.filter(item => item.hitEventId.toString() !== payload.params.hitEventId.toString())
        ]
      }
    };
  }
  else {
    return state;
  }

};

export const onRemoveTicketRequest = (state) => ({ ...state, isLoading: true });
export const onRemoveTicketFailure = (state) => ({ ...state, isLoading: false });
export const onRemoveTicketSuccess = (state, { payload }) => {

  let hitEvents = _.cloneDeep(_.get(`hitEvents.content`)(state) || {});

  if(hitEvents.length) {
    const currentHitEventIndex = hitEvents.findIndex((hitEvent) => (
      (hitEvent || {}).hitEventId.toString() === payload.params.hitEventId.toString()
    ));

    if(currentHitEventIndex > -1) {
      
      hitEvents[currentHitEventIndex].ticketTypes.splice(hitEvents[currentHitEventIndex].ticketTypes.findIndex((ticket) => {
        return ticket.productOfferId.toString() === payload.params.productOfferId.toString();
      }), 1);

      state.isLoading = false
      return _.set(`hitEvents.content`, hitEvents)(state);
    }
  
  }

  return ({ ...state, isLoading: false })

};

export const onEditHitEventRequest = (state, { params }) => ({ ...state, isLoading: true });
export const onEditHitEventFailure = (state) => ({ ...state, isLoading: false });
export const onEditHitEventSuccess = (state, { payload }) => {

  return {
    ...state,
    isLoading: false,
    hitEvents: { 
      ...state.hitEvents,
      content: state.hitEvents.content.map(hitEvent => 
        (hitEvent || {}).hitEventId === payload.hitEventId ? 
          { ...hitEvent, ...payload } : hitEvent
      )
    }
  };
  
};

export const onGetParametersEditHitEventRequest = (state, { params }) => ({ ...state, isLoading: true });
export const onGetParametersEditHitEventFailure = (state) => ({ ...state, isLoading: false });
export const onGetParametersEditHitEventSuccess = (state, { payload }) => {
  return {
    ...state,
    isLoading: false,
    hitEvents: { 
      ...state.hitEvents,
      content: state.hitEvents.content.map(hitEvent => 
        (hitEvent || {}).hitEventId === payload.hitEventId ? 
          { ...hitEvent, ...payload.data } : hitEvent
      )
    }
  };
}

export const ACTIONS_HANDLER = {
  [COMPANY.GET_ALL_REQUEST]: onGetAllRequest,
  [COMPANY.GET_ALL_SUCCESS]: onGetAllSuccess,
  [COMPANY.GET_ALL_FAILURE]: onGetAllFailure,
  [COMPANY.GET_DETAIL_REQUEST]: onGetDetailRequest,
  [COMPANY.GET_DETAIL_SUCCESS]: onGetDetailSuccess,
  [COMPANY.GET_DETAIL_FAILURE]: onGetDetailFailure,
  [COMPANY.GET_FOLLOWERS_REQUEST]: onGetCompanyFollowersRequest,
  [COMPANY.GET_FOLLOWERS_SUCCESS]: onGetCompanyFollowersSuccess,
  [COMPANY.GET_FOLLOWERS_FAILURE]: onGetCompanyFollowersFailure,
  [COMPANY_ONBOARDING.CREATE_COMPANY_SUCCESS]: onCreateCompanySuccess, 
  [COMPANY.GET_FEED_REQUEST]: onGetFeedRequest,
  [COMPANY.GET_FEED_SUCCESS]: onGetFeedSuccess,
  [COMPANY.GET_FEED_FAILURE]: onGetFeedFailure,
  [COMPANY.CREATE_FEED_POST_REQUEST]: onCreateCompanyPostRequest,
  [COMPANY.CREATE_FEED_POST_SUCCESS]: onCreateCompanyPostSuccess,
  [COMPANY.CREATE_FEED_POST_FAILURE]: onCreateCompanyPostFailure,
  [COMPANY.CREATE_USER_REQUEST]: onCreateUserRequest,
  [COMPANY.CREATE_USER_SUCCESS]: onCreateUserSuccess,
  [COMPANY.CREATE_USER_FAILURE]: onCreateUserFailure,
  [COMPANY.UPDATE_COMPANY_REQUEST]: onUpdateCompanyRequest,
  [COMPANY.UPDATE_COMPANY_SUCCESS]: onUpdateCompanySuccess,
  [COMPANY.UPDATE_COMPANY_FAILURE]: onUpdateCompanyFailure,
  [COMPANY.UPDATE_COMPANY_USER_REQUEST]: onUpdateCompanyUserRequest,
  [COMPANY.UPDATE_COMPANY_USER_SUCCESS]: onUpdateCompanyUserSuccess,
  [COMPANY.UPDATE_COMPANY_USER_FAILURE]: onUpdateCompanyUserFailure,
  [COMPANY.DELETE_HITPOST_SUCCESS] : onDeleteHitPostSuccess,
  // [COMPANY.UPDATE_COMPANY_COVER_IMAGE_REQUEST]: onUpdateCompanyCoverImageRequest,
  [COMPANY.UPDATE_COMPANY_COVER_IMAGE_SUCCESS]: onUpdateCompanyCoverImageSuccess,
  // [COMPANY.UPDATE_COMPANY_COVER_IMAGE_FAILURE]: onUpdateCompanyCoverImageFailure,
  [LIKES.DELETE_SUCCESS]: onLikeDelete,
  [LIKES.CREATE_SUCCESS]: onLikeCreate,
  [COMMENTS.CREATE_SUCCESS]: onCommentCreate,
  [COMMENTS.DELETE_SUCCESS]: onCommentDelete,
  [HITFACTOR_COLLECTIONS.CREATE_SUCCESS]: onCreateCollectionSuccess,
  [HITFACTOR_COLLECTIONS.CREATE_IMAGE_SUCCESS]: onCreateCollectionImageSuccess,
  [HITFACTOR_COLLECTIONS.UPDATE_IMAGE_SUCCESS]: onUpdateCollectionImageSuccess,
  [HITFACTOR_COLLECTIONS.DELETE_COLLECTION_SUCCESS]: onDeleteCollectionSuccess,
  [HITFACTOR_COLLECTIONS.DELETE_IMAGE_SUCCESS]: onDeleteImageSuccess,
  [HITFACTOR_COLLECTIONS.UPDATE_SUCCESS]: onUpdateCollectionSuccess,
  [HITFACTOR_COLLECTIONS.MOVE_IMAGE_REQUEST]: onMoveImageImageRequest,
  [HITFACTOR_COLLECTIONS.MOVE_COLLECTION_REQUEST]: onMoveCollectionRequest,
  [COMPANY.CONNECT_INSTAGRAM_REQUEST]: onConnectInstagramRequest,
  [COMPANY.CONNECT_INSTAGRAM_FAILURE]: onConnectInstagramFailure,
  [COMPANY.CONNECT_INSTAGRAM_SUCCESS]: onConnectInstagramSuccess,
  [COMPANY.DELETE_INSTAGRAM_REQUEST]: onDeleteInstagramRequest,
  [COMPANY.DELETE_INSTAGRAM_FAILURE]: onDeleteInstagramFailure,
  [COMPANY.DELETE_INSTAGRAM_SUCCESS]: onDeleteInstagramSuccess,
  [COMPANY.GET_HITEVENTS_REQUEST]: onGetCompanyHitEventsRequest,
  [COMPANY.GET_HITEVENTS_FAILURE]: onGetCompanyHitEventsFailure,
  [COMPANY.GET_HITEVENTS_SUCCESS]: onGetCompanyHitEventsSuccess,
  [COMPANY.GET_HITEVENTS_DEBOUNCED_REQUEST]: onGetCompanyHitEventsRequest,
  [COMPANY.GET_HITEVENTS_DEBOUNCED_FAILURE]: onGetCompanyHitEventsFailure,
  [COMPANY.GET_HITEVENTS_DEBOUNCED_SUCCESS]: onGetCompanyHitEventsSuccess,
  [HITCLUB.CREATE_HITEVENT_REQUEST]: onCreateHitEventRequest,
  [HITCLUB.CREATE_HITEVENT_FAILURE]: onCreateHitEventFailure,
  [HITCLUB.CREATE_HITEVENT_SUCCESS]: onCreateHitEventSuccess,
  [HITCLUB.REMOVE_HITEVENT_REQUEST]: onRemoveHitEventRequest,
  [HITCLUB.REMOVE_HITEVENT_FAILURE]: onRemoveHitEventFailure,
  [HITCLUB.REMOVE_HITEVENT_SUCCESS]: onRemoveHitEventSuccess,
  [HITCLUB.EDIT_HITEVENT_REQUEST]: onEditHitEventRequest,
  [HITCLUB.EDIT_HITEVENT_FAILURE]: onEditHitEventFailure,
  [HITCLUB.EDIT_HITEVENT_SUCCESS]: onEditHitEventSuccess,
  [HITCLUB.CREATE_TICKET_REQUEST]: onCreateTicketRequest,
  [HITCLUB.CREATE_TICKET_FAILURE]: onCreateTicketFailure,
  [HITCLUB.CREATE_TICKET_SUCCESS]: onCreateTicketSuccess,
  [HITCLUB.EDIT_TICKET_REQUEST]: onEditTicketRequest,
  [HITCLUB.EDIT_TICKET_FAILURE]: onEditTicketFailure,
  [HITCLUB.EDIT_TICKET_SUCCESS]: onEditTicketSuccess,
  [HITCLUB.REMOVE_TICKET_REQUEST]: onRemoveTicketRequest,
  [HITCLUB.REMOVE_TICKET_FAILURE]: onRemoveTicketFailure,
  [HITCLUB.REMOVE_TICKET_SUCCESS]: onRemoveTicketSuccess,
  [HITCLUB.CREATE_TICKET_QUESTIONS_REQUEST]: onCreateTicketQuestionsRequest,
  [HITCLUB.CREATE_TICKET_QUESTIONS_FAILURE]: onCreateTicketQuestionsFailure,
  [HITCLUB.CREATE_TICKET_QUESTIONS_SUCCESS]: onCreateTicketQuestionsSuccess,
  [HITCLUB.EDIT_TICKET_QUESTIONS_REQUEST]: onEditTicketQuestionsRequest,
  [HITCLUB.EDIT_TICKET_QUESTIONS_FAILURE]: onEditTicketQuestionsFailure,
  [HITCLUB.EDIT_TICKET_QUESTIONS_SUCCESS]: onEditTicketQuestionsSuccess,
  [HITCLUB.EDIT_HITEVENT_PARAMETERS_REQUEST] : onGetParametersEditHitEventRequest,
  [HITCLUB.EDIT_HITEVENT_PARAMETERS_FAILURE] : onGetParametersEditHitEventFailure,
  [HITCLUB.EDIT_HITEVENT_PARAMETERS_SUCCESS] : onGetParametersEditHitEventSuccess,
};

export default createReducer(INITIAL_STATE, ACTIONS_HANDLER);
